import { render, staticRenderFns } from "./campaign-colors.vue?vue&type=template&id=50ef90a6&scoped=true&"
import script from "./campaign-colors.vue?vue&type=script&lang=js&"
export * from "./campaign-colors.vue?vue&type=script&lang=js&"
import style0 from "./campaign-colors.vue?vue&type=style&index=0&id=50ef90a6&prod&lang=scss&scoped=true&"
import style1 from "./campaign-colors.vue?vue&type=style&index=1&id=50ef90a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef90a6",
  null
  
)

export default component.exports